import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Observable, debounceTime, distinctUntilChanged, firstValueFrom, of, startWith, switchMap } from "rxjs";
import { IDetailItemExpense, getEmptyDetailItemExpense } from "../expenses.interface";
import { AlertService } from "../../../../shared/services/alert.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { ProductsService } from "../../../products-page/products/products.service";
import { VendorsService } from "../../../vendors-page/vendors/vendors.service";
import { IVendor } from "../../../vendors-page/vendors/vendors.interface";

@Component({
  selector: 'app-detail-list-expenses',
  templateUrl: './detail-list-expenses.component.html',
  styleUrls: ['./detail-list-expenses.component.css']
})
export class DetailListExpensesComponent implements OnInit {

  @Input('header') header = true;
  @Input('footer') footer = true;
  @Input('readOnly') readOnly = false;
  @Input('pricing') pricing = true;
  @Input('items') items!: IDetailItemExpense[];
  @Input('taxPercentage') taxPercentage: number = 0;
  @Output('listChange') listChange = new EventEmitter<any>();
  form!: UntypedFormGroup;
  totals = { total: 0, subtotal: 0, tax: 0, costsubtotal: 0 };
  openDetails = [];
  curr!: string;
  loading = true;
  disableButton = false;

  emptyItem = getEmptyDetailItemExpense();

  // por rendimiento seran entregados desde aqui
  vendors!: IVendor[];

  constructor(
    private _AuthService: AuthService,
    private _ProductsService: ProductsService,
    private _VendorsService: VendorsService,
    private fb: UntypedFormBuilder,
    private _AlertService: AlertService,
  ) { }

  ngOnInit(): void {
    this.initializeComponent();
  }

  async initializeComponent() {
    await this.getVendors();
    this.curr = this._AuthService.currency();
    // if (!(this.items?.length > 0)) throw new Error('Item list not initialized');
    this.items.length <= 1 ? this.disableButton = true : this.disableButton = false;
    this.calculateTotals();
    this.loading = false;
  }

  async getVendors() {
    this.vendors = await firstValueFrom(this._VendorsService.getVendors({
      filters: {},
      company: this._AuthService.companyId(),
      sort: 'name',
      skip: 0,
      limit: 10000
    }))
  }

  addItem() {
    if (this.items.length > 0) {
      const lastItem = this.items[this.items.length - 1];
      if (lastItem.name === "")
        return this._AlertService.warn("Para añadir una nueva línea, por favor complete la anterior");
    }
    this.items.push(getEmptyDetailItemExpense())
    this.calculateTotals();
  }

  onItemChange(item: any, event: any) {
    // console.log(event);
    this.items.forEach(el => {
      // try { el.tax = parseFloat(el.tax as any) } catch (e) { }
      // try { el.subtotal = parseFloat(el.subtotal as any) } catch (e) { }
      // try { el.cost = parseFloat(el.cost as any) } catch (e) { }
    })
    this.items.length <= 1 ? this.disableButton = true : this.disableButton = false;
    this.calculateTotals();
  }

  onRemove(item: any) {
    const index = this.items.indexOf(item);
    this.items.splice(index, 1);
    this.items.length <= 1 ? this.disableButton = true : this.disableButton = false;
    this.calculateTotals();
  }

  calculateTotals() {
    // console.log(this.items);
    const items: any = this.items;
    // try { this.totals.cost = this.items.reduce((acc, el) => acc + (+(el.cost ?? 0)), 0) } catch (e) { this.totals.cost = 0 }
    // try { this.totals.subtotal = this.items.reduce((acc, el) => acc + (+(el.subtotal ?? 0)), 0) } catch (e) { this.totals.subtotal = 0 }
    // try { this.totals.tax = this.items.reduce((acc, el) => acc + (+(el.tax ?? 0)), 0) } catch (e) { this.totals.tax = 0 }
    try { this.totals.subtotal = items.reduce((acc: any, el: any) => acc + (+(el.subtotal ?? 0)), 0) } catch (e) { this.totals.subtotal = 0 }
    try { this.totals.tax = items.reduce((acc: any, el: any) => acc + (+(el.tax ?? 0)), 0) } catch (e) { this.totals.tax = 0 }
    // try { this.totals.total = this.items.reduce((acc, el) => acc + (+(el.total ?? 0)), 0) } catch (e) { this.totals.total = 0 }
    this.totals.total = this.totals.subtotal + this.totals.tax;
    let data = { items: this.items, totals: this.totals }
    this.listChange.emit(data);
  }
}